import { gql } from '@apollo/client';

export const UPDATE_DAILYMOTION_VIDEO_THUMBNAIL = gql`
  mutation UpdateDailymotionVideoThumbnail(
    $brandKey: BrandKey!
    $dailymotionPublicId: ID!
    $thumbnailUrl: URL!
  ) {
    updateDailymotionVideoThumbnail(
      brandKey: $brandKey
      dailymotionPublicId: $dailymotionPublicId
      thumbnailUrl: $thumbnailUrl
    )
  }
`;
